export default __webpack_public_path__ + "static/media/logo-portas-abertas.8c91c5fa.png";